import styled, { keyframes, css } from 'styled-components';
import { media as oldMedia, hexa } from 'legacyComponents/styled/styleUtils';

import { Link } from 'core/routing';
import Heading from 'components/Heading';

// animations
export const loading = keyframes`
  0% { background-position:0% 50% }
  50% { background-position:100% 50% }
  100% { background-position:0% 50% }
`;

export const ButtonsContainer = styled.div`
  > button {
    margin: 0 6px;
  }
`;

export const GreenDot = styled.span`
  color: ${props => props.theme.color.wfGreen};
`;

export const UnstyledLink = styled.a`
  color: inherit;
`;

export const StyledLink = styled(Link)`
  color: ${props => props.theme.color.primary};
  &:hover {
    text-decoration: underline;
  }
`;

export const Div = styled.div`
  float: ${props => props.float};
  position: ${props => props.position};
  display: ${props => props.display};
  margin: ${props => props.margin};
  height: ${props => props.height};
  width: ${props => props.width};
  vertical-align: ${props => props.verticalAlign};
`;

// components
export const ProfileNoContent = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 40px;
  font-size: 1em;
  text-align: center;
  background-color: ${props => props.theme.color.wfGrey100};
  border-top: 1px solid ${props => props.theme.color.wfGrey200};
  line-height: 1.4;
  color: ${props => props.theme.color.wfGrey};
  padding: 20px;
  font-size: 0.85em;
`;

export const BlueTopBar = styled.div`
  width: 100%;
  height: 158px;
  position: relative;
  color: ${props => props.theme.color.wfBlack};
  /* background-color: ${props => props.theme.color.wfBlue}; */
`;

export const BlueTopBarTitle = styled.h1`
  font-size: 1.375em;
  color: ${props => props.theme.color.wfBlack};
  text-align: center;
  padding-top: ${props => (props.elevated ? '33px' : '44px')};
  margin-top: 0;
  ${oldMedia.s`
    font-size: 1.1em;
  `};
`;

export const Button = styled.button`
  /* propTypes: toggle, danger, invisible, marginLeft, marginRight  */
  display: ${props => props.display || 'block'};
  font-size: ${props => (props.small ? '0.8125em' : '1em')};
  font-weight: 400;
  height: ${props => (props.small ? '32px' : props.medium ? '34px' : '37px')};
  padding: ${props => (props.small ? '0px 16px' : '0px 18px')};
  background-color: ${props =>
    props.toggle
      ? 'transparent'
      : props.danger
      ? props.theme.color.wfWhite
      : props.theme.color.primary};
  color: ${props =>
    props.toggle
      ? props.theme.color.primary
      : props.danger
      ? props.theme.color.wfOrange
      : props.theme.color.wfWhite};
  border: 1px solid
    ${props =>
      props.danger ? props.theme.color.wfOrange : props.theme.color.primary};
  border-radius: 20px;
  transition: ${props =>
    props.toggle
      ? 'background-color 200ms ease-in-out, color 200ms ease-in-out, border 200ms ease-in-out'
      : 'opacity 300ms ease-in-out'};
  opacity: ${props => (props.invisible ? '0' : '1')};
  pointer-events: ${props => (props.invisible ? 'none' : 'auto')};
  margin-right: ${props => props.marginRight || '0px'};
  margin-left: ${props => props.marginLeft || '0px'};
  margin-top: ${props => props.marginTop || '0px'};
  margin-bottom: ${props => props.marginBottom || '0px'};
  float: ${props => props.float || 'initial'};
  &:hover {
    cursor: ${props => (props.posting ? 'progress' : 'pointer')};
    background-color: ${props =>
      props.toggle
        ? props.theme.color.primary
        : props.danger
        ? props.theme.color.wfOrange200
        : props.theme.color.primaryLight};
    border: 1px solid
      ${props =>
        props.toggle
          ? props.theme.color.primary
          : props.danger
          ? props.theme.color.wfOrange200
          : props.theme.color.primaryLight};
    color: ${props => props.theme.color.wfWhite};
  }
`;

export const Center = styled.div`
  /* centers any component horizontally */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  min-height: ${props => (props.inherit ? 'inherit' : 'auto')};
`;

export const CommentSection = styled.div`
  width: 100%;
  height: auto;
  padding: 20px 0;
  background-color: rgb(250, 250, 250);
  border-top: 1px solid rgba(0, 0, 0, 0.0470588);
`;

export const CommentsWrapper = styled.div`
  width: 700px;
  margin: 0 auto;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: ${props => props.color || props.theme.color.wfGrey200};
  display: block;
  margin: ${props => props.margin || '0px auto'};
  ${oldMedia.s`
    width: ${props => props.width || `calc(100% - 60px)`};
  `};
  ${oldMedia.xs`
    width: ${props => props.width || `calc(100% - 60px)`};
  `};
`;

export const FullWidthDivider = styled(Divider)`
  width: 100%;
`;

export const HeaderMarginTop = styled.div`
  margin: ${props => (props.noMargin ? '0' : props.margin)};
`;

export const Icon = styled.div`
  /* propTypes: className, circled, padding */
  display: inline-block;
  width: ${props => (props.width ? props.width : '38px')};
  height: ${props => (props.height ? props.width : '38px')};
  font-size: ${props => (props.fontSize ? props.fontSize : '21px')};
  border: ${props =>
    props.circled ? `1px solid ${props.theme.color.wfGrey500}` : 'none'};
  border-radius: ${props => (props.circled ? '20px' : 'initial')};
  color: ${props => props.theme.color.wfGrey500};
  padding: ${props => (props.padding ? props.padding : '6px 11px')};
  transition: border 100ms ease-in-out, color 100ms ease-in-out;
  &:hover {
    border: ${props =>
      props.circled ? `1px solid ${props.theme.color.primary}` : 'none'};
    color: ${props => props.theme.color.primary};
    cursor: pointer;
  }
`;

const loadingAnimation = css`
  animation: ${loading} 1.1s ease infinite;
`;

export const Indicator = styled.div`
  height: ${props => props.height || '20px'};
  width: ${props => props.width || '100%'};
  background: linear-gradient(270deg, #f2f2f2, #e5e5e5);
  background-size: 200% 200%;
  margin: ${props => props.margin || '0'};
  ${props => (props.static ? 'animation: none;' : loadingAnimation)}
  transform: rotateZ(360deg);
`;

export const CrumbsWrapper = styled.div`
  margin-top: 30px;
`;

export const IssueWrapper = styled.div`
  margin: 20px auto 120px auto;
  position: relative;
  width: 100%;
  background-color: ${props => props.theme.color.wfWhite};
  display: block;
  border: 1px solid ${props => props.theme.color.wfGrey300};
  padding: 0 ${props => props.theme.spacing.large};
  z-index: 2;
  &:hover {
    box-shadow: 0 1px 1px rgba(44, 45, 48, 0.07);
  }
  ${oldMedia.s`
    padding: 25px 15px 0;
  `};
`;

export const AvatarIndicator = styled(Indicator)`
  width: ${props => (props.size ? props.size : '42px')};
  height: ${props => (props.size ? props.size : '42px')};
  border-radius: 100%;
  ${oldMedia.l`
    width: ${props => (props.size ? props.size : '38px')};
    height: ${props => (props.size ? props.size : '38px')};
  `};
`;

export const Input = styled.input`
  width: ${props => props.width || '100%'};
  margin: 5px 0 15px 0;
  color: ${props => props.theme.color.wfGrey900};
  font-size: 0.875em;
  border: 1px solid ${props => props.theme.color.wfGrey200};
  padding: 12px 10px;
  :focus {
    border: 1px solid ${props => props.theme.color.wfGrey400};
    outline: 0;
  }
  :active {
    outline: none;
  }
`;

export const BaseEditField = styled.div`
  background-color: ${props => props.theme.color.wfWhite};
  border: 1px solid
    ${props =>
      props.focussed ? props.theme.color.wfBlue : props.theme.color.wfGrey500};
  color: ${props => props.theme.color.wfBlack};
  padding: 0 ${props => props.theme.spacing.small};
`;

export const Label = styled.div`
  font-weight: ${props => props.theme.font.weight.xbold};
  display: ${props => (props.block ? 'none' : 'inline-block')};
  border-radius: ${props => props.theme.borderRadius.large};
  line-height: 1;
  color: ${props => props.backgroundColor};
  padding: 0.5em 1em;
  background-color: ${props => hexa(props.backgroundColor, 0.1)};
  border: 1px solid ${props => hexa(props.backgroundColor, 0.8)};
  margin-right: ${props => props.theme.spacing.small};
  cursor: ${props => (props.cursor ? props.cursor : 'default')};
  font-size: ${props =>
    props.small ? props.theme.font.size.xsmall : props.theme.font.size.small};
  ${oldMedia.m`
    display: ${props =>
      props.block ? 'inline-block' : props.fixed ? 'inline-block' : 'none'};
    margin-top: ${props => (props.fixed ? '0px' : '10px')};
  `};
`;

// TODO: move this component to shared file
export const MainWrapper = styled.div`
  position: relative;
  display: block;
  max-width: ${props => props.theme.layout.maxWidth};
  margin: 0 auto;
  padding: 0 ${props => props.theme.layout.paddingInline};
  margin-top: ${props => (props.marginTop ? props.marginTop : '0')};
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '0')};
`;

export const FullWidthWrapper = styled.div`
  width: 100%;
  padding: 0 20px;
  margin-top: ${props => (props.marginTop ? props.marginTop : '0')};
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '0')};
`;

export const ModalHeader = styled.header`
  padding: ${props => props.theme.spacing.small} 0;
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  text-align: center;
`;

export const ModalTitle = styled(Heading)`
  font-size: ${props => props.theme.font.size.xmedium};
  margin-top: 0;
  color: ${props => !props.variant && props.theme.color.wfBlack};
  margin-bottom: ${props => props.theme.spacing.default};
  padding: 0;
`;

export const ModalSubtitle = styled(Heading)`
  color: ${props => props.theme.color.wfGrey500};
  margin-bottom: ${props => props.theme.spacing.default};
  text-align: center;
`;

export const ModalContentWrapper = styled.div`
  width: 600px;
  display: block;
  margin-right: auto;
  margin-left: auto;
  ${oldMedia.m`
    width: 100%;
  `}
`;

export const Overlay = styled.div`
  /* TODO: deal with pointer events on children */
  transition: opacity 300ms ease-in-out;
  opacity: ${props => (props.active ? '0.3' : ' 1')};
  width: 100%;
  height: 100%;
`;

export const ProfileWrapper = styled.div`
  height: 300px;
`;

export const P = styled.p`
  font-size: ${props => props.theme.spacing.medium};
  line-height: 1.5;
  font-style: ${props => props.fontStyle};
  ${oldMedia.s`
    font-size: 17px;
  `}
`;

export const ProfileUsername = styled.h5`
  text-align: center;
  font-size: 0.875em;
  margin: 5px 0 5px 0;
  font-weight: 600;
  color: ${props => props.theme.color.primary};
`;

export const WarningButton = styled(Button)`
  background-color: ${props => props.theme.color.wfYellow200};
  color: ${props => props.theme.color.wfYellow};
  border: 1px solid ${props => props.theme.color.wfYellow};
  &:hover {
    background-color: ${props => props.theme.color.wfYellow};
    color: ${props => props.theme.color.wfWhite};
    border: 1px solid ${props => props.theme.color.wfYellow};
  }
`;

export const Message = styled.div`
  padding: 10px;
  font-size: 14px;
  padding: 5px 0 30px 0;
  color: ${props => props.theme.color.wfGrey900};
  a {
    color: ${props => props.theme.color.primary};
    text-decoration: underline;
  }
`;

export const ProjectCard = styled.div`
  width: 386px;
  background-color: ${props => props.theme.color.wfWhite};
  box-shadow: rgba(75, 75, 75, 0.2) 0 1px 1px;
  display: inline-block;
  vertical-align: top;
  margin-right: ${props => (props.noMargin ? '0px' : '30px')};
  margin-bottom: 30px;
  &:hover {
    > a > img {
      opacity: 0.9;
    }
    > div > a > h3 {
      color: ${props => props.theme.color.primary};
    }
  }
  ${oldMedia.l`
      width: 346px;
      margin-right: ${props => (props.noMargin ? '0px' : '30px')};
    `};
  ${oldMedia.m`
      width: 375px;
      margin-right: ${props => (props.noMargin ? '0px' : '30px')};
    `};
  ${oldMedia.s`
      width: 300px;
      margin-right: ${props => (props.noMargin ? '0px' : '20px')};
      margin-bottom: 20px;
    `};
  ${oldMedia.xs`
      width: 100%;
      margin-right: ${props => (props.noMargin ? '0px' : '0px')};
    `};
`;

export const SubPageWrapper = styled.div`
  width: ${props => (props.width ? props.width : '77%')};
  padding: ${props =>
    `${props.theme.spacing.medium} ${props.theme.spacing.large} ${props.theme.spacing.large} 0`};
  display: inline-block;
  border-right: 1px solid ${props => props.theme.color.wfGrey200};
  min-height: 300px;
  ${oldMedia.m`
    width: 100%;
    border-right: none;
    padding: 0 0 30px 0;
  `};
`;

export const SubPageStatsWrapper = styled.div`
  width: ${props =>
    props.width ? `calc(${props.width} - 1px) ` : 'calc(23% - 1px)'};
  padding: ${props =>
    `${props.theme.spacing.medium} 0 0 ${props.theme.spacing.medium}`};
  display: inline-block;
  vertical-align: top;
  ${oldMedia.m`
    display: none;
  `};
`;

export const SectionHeaderButton = styled(Icon)`
  float: right;
  margin-left: 12px;
  border: ${props =>
    props.blue
      ? `1px solid ${props.theme.color.primary}`
      : '1px solid rgba(0,0,0,0.2)'};
  font-size: 24px;
  padding: ${props => props.padding || '6px 0 0 8px'};
  color: ${props =>
    props.blue ? props.theme.color.primary : props.theme.color.wfGrey500};
  background-color: ${props => props.backgroundColor || 'transparent'};
  ${oldMedia.m`
    margin-right: 15px;
  `}
  ${oldMedia.s`
    display: none;
  `}
`;

export const SettingsIcon = styled(Icon)`
  border: 1px solid ${props => props.theme.color.primary};
  color: ${props => props.theme.color.primary};
  font-size: 24px;
  padding: 6px 9px;
  margin-left: 6px;
`;

export const SettingsSection = styled.div`
  padding: 0px 30px 0px;
  margin-bottom: 2rem;
  /* FIXME: apply this margin inside paragraph component */
  p {
    margin: ${props => props.theme.spacing.default} 0;
  }
  > p > a {
    color: ${props => props.theme.color.primary};
    text-decoration: underline;
  }
`;

export const DeleteIcon = styled(SettingsIcon)`
  border: 1px solid ${props => props.theme.color.wfGrey500};
  color: ${props => props.theme.color.wfGrey500};
  padding: 6px 12px;
  font-size: 23px;
  &:hover {
    border: 1px solid ${props => props.theme.color.wfOrange};
    color: ${props => props.theme.color.wfOrange};
  }
`;

export const SubPageStatName = styled.p`
  margin: ${props => (props.first ? '0 0 10px 0' : ' 30px 0 10px 0')};
  font-weight: 600;
  font-size: 1.125em;
`;

export const SubPageStat = styled.p`
  margin: 0 0 25px 20px;
  font-size: 0.9375em;
`;

export const SubPageTitle = styled.h2`
  font-size: ${props => props.theme.font.size.large};
  margin-bottom: ${props => props.theme.spacing.small};
  line-height: ${props => (props.noLineHeight ? 'normal' : '1.6')};
  &:hover {
    > span:nth-of-type(1) {
      text-decoration: ${props => (props.link ? 'underline' : 'none')};
    }
  }
  ${oldMedia.s`
    font-size: 1.2em;
  `};
`;

export const SubPageDescription = styled.div`
  line-height: 1.6;
  color: ${props =>
    props.empty ? props.theme.color.wfGrey900 : props.theme.color.wfGrey};
  margin: ${props => (props.empty ? '0 0 20px 0' : '0')};
`;

export const SubPageInfo = styled.div`
  display: inline-block;
  margin-bottom: ${props => props.theme.spacing.medium};
  font-size: ${props => props.theme.font.size.small};
  color: ${props => props.theme.color.wfGrey900};
  ${oldMedia.s`
    line-height: 1.4;
    margin: 0 0 15px 0;
  `};
`;

export const SubPageDivider = styled.div`
  height: 1px;
  background-color: #eee;
  display: block;
  margin: 20px auto 10px auto;
  width: 100%;
`;

export const Tab = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  border: ${props =>
    props.noShadow ? `none` : `1px solid ${props.theme.color.wfGrey300}`};
  margin: ${props => props.margin || '0px auto 20px'};
`;

export const TabHeight = styled(Tab)`
  min-height: 230px;
`;

export const Tag = styled.div`
  /* FIXME: Replace this component by Badge component */
  display: flex;
  align-items: center;
  width: fit-content;
  border-radius: ${props => props.theme.borderRadius.large};
  background-color: ${props => props.theme.color.wfGrey200};
  padding: 0.5em 1em 0.6em;
  font-size: ${props =>
    props.size
      ? props.theme.font.size[props.size]
      : props.theme.font.size.small};
  color: ${props => props.theme.color.wfBlack};
  transition: color 100ms ease-in-out;
  margin-top: ${props => props.main && props.theme.spacing.medium};
  margin-right: ${props =>
    props.last
      ? '0'
      : props.profile
      ? props.theme.spacing.default
      : props.main
      ? '0'
      : props.small
      ? props.theme.spacing.small
      : props.vertical
      ? '0'
      : props.theme.spacing.medium};
  margin-bottom: ${props =>
    props.marginBottom
      ? props.theme.spacing.default
      : props.vertical && props.theme.spacing.default};
  margin-left: ${props => props.vertical && props.theme.spacing.medium};
  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.color.wfGrey300};
  }
  svg {
    min-width: 1rem;
  }
  ${oldMedia.s`
      font-size: ${props => (props.main ? '1.375em' : '0.6em')};
      margin-right: ${props =>
        props.last
          ? '0px'
          : props.profile
          ? '18px'
          : props.main
          ? '0px'
          : '22px'};
  `};
`;

export const TagDeleteButton = styled.span`
  display: inline-block;
  margin-left: 10px;
  color: ${props => props.theme.color.wfOrange};
  &:hover {
    transform: scale(1.3);
  }
`;

export const TagsTitle = styled.p`
  display: inline-block;
  font-weight: 600;
  font-size: 12px;
  color: ${props =>
    props.hidden ? 'transparent' : `${props.theme.color.wfGrey900}`};
  margin: 0 1rem 1rem 0;
  ${oldMedia.m`
    display: none;
  `};
`;

export const Triangle = styled.div`
  border-color: transparent;
  border-style: dashed dashed solid;
  border-width: 0 8.5px 8.5px;
  border-bottom-color: ${props =>
    props.top
      ? props.theme.color.greyLight
      : props.bottom
      ? props.theme.color.wfWhite
      : ''};
  position: absolute;
  z-index: 101;
  height: 0;
  width: 0;
`;

export const InlineInput = styled.input`
  width: ${props => props.width};
  background-color: ${props => props.theme.color.wfGrey100};
  font-size: ${props => props.fontSize};
  margin: ${props => props.margin};
  display: block;
  font-weight: ${props => props.fontWeight || '400'};
  color: ${props => props.theme.color.wfGrey900};
  border: 1px solid ${props => props.theme.color.wfGrey100};
  border-radius: ${props => props.borderRadius};
`;
